import { ICONS, IMAGES } from '@/constants/constants'
import Image from 'next/image'
import React from 'react'

interface HeadingProps {
  heading?: string;
  subheading?: string;
  icon?: string;
  className?: string;
  headingStyle?: string;
  isIcon?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
  heading = 'FERRY SCHEDULE',
  subheading = 'Aero Point ↔ Tuck Inlet',
  icon = ICONS.redline2,
  className = '',
  headingStyle = '',
  isIcon = true
}) => {
  return (
    <div className={`font-work-sans ${className}`}>
      <h1 className={`font-rakesly text-4xl ${headingStyle}  font-bold`}>{heading}</h1>
      <p className='text-sm text-gray-600'>{subheading}</p>
      {
        isIcon && <Image src={icon} alt='redline' width={180} height={100} />}

    </div>
  )
}

export default Heading